import { Route } from '@angular/router';

import { OfflineDashboardComponent } from './offline-dashboard/offline-dashboard.component';
import { OfflineGuidelineViewComponent } from './offline-guideline-view/offline-guideline-view.component';
import { OfflinePageComponent } from './offline-page.component';

export const OFFLINE_PAGE_ROUTES: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'smartbook/dashboard',
  },
  {
    path: '',
    component: OfflinePageComponent,
    children: [
      {
        path: 'smartbook/dashboard',
        component: OfflineDashboardComponent,
      },
      {
        path: 'guideline/:id',
        component: OfflineGuidelineViewComponent,
        data: { availableOffline: true },
      },
    ],
  },
];
